import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, H4, NumericInput,  InputGroup, Switch } from '@blueprintjs/core';
import { withTranslation } from 'react-i18next';


class AlrParams extends React.PureComponent {

  handleBoolToTextChange = (e) => {
        const name = e.target.name;

        const newBoolValue = !this.props.values[name];
        const newIntValue = newBoolValue ? 1 : 0;
        this.props.onValueChange('alrParamValues', name, newIntValue);
  }
  // bizarrement pour les champs textes il faut utiliser un autre mécanisme de validation
  handleCollocCatFilterChange = (e) => {
    const newValue = e.target.value;
    this.props.onValueChange('alrParamValues', 'collocCatFilter', newValue);
  }
  handleFreqMinAlrChange = (e) => {
    const newValue = e.target.value;
    this.props.onValueChange('alrParamValues', 'freqMinAlr', newValue.split(","));
  }

  render() {

    const {
      collocCatFilter,
      dispMinAlr,
      minSize,
      maxSize,
      amThreshold,
      maxNbCollocs,
      minFreqChildrenRatio4Deduplicating,
      useCollig,
      mergeAlr
    } = this.props.values;

    var freqMinAlr=this.props.values.freqMinAlr[0];
    for (var i=1;i<this.props.values.freqMinAlr.length;i++) {
      freqMinAlr+=","+this.props.values.freqMinAlr[i];
    }

    // const sizeRange=[parseInt(minSize),parseInt(maxSize)];

    const { onValueChange,t } = this.props;

    const formGroupStyle = {
      display: 'flex',
      justifyContent: 'space-between',
    };

    return (
      <>
        <H4><u>{t('alrDefinition')}</u></H4>

  
  {/*   
          <RangeSlider
            min={0}
            max={20}
            disabled={false}
            labelStepSize={5}
            value={sizeRange}
            onChange={(newValue) => onValueChange('alrParamValues', 'sizeRange', newValue)}
   /> */}
        <FormGroup
          helperText={t('sizeHelp')}
          label={t('minSizeMaxSize')}
          inline={true}
          style={formGroupStyle}
        >
          <NumericInput
            min={0} buttonPosition={null}
            value={minSize}
            onValueChange={(newValue) => onValueChange('alrParamValues', 'minSize', newValue)}
          />
          <NumericInput
            min={0} buttonPosition={null}
            value={maxSize}
            onValueChange={(newValue) => onValueChange('alrParamValues', 'maxSize', newValue)}
          />
        </FormGroup>

        <FormGroup
          helperText={t('freqMinAlrHelp')}
          label={t('freqMinAlr')}
          inline={true}
          style={formGroupStyle}
        >
          <InputGroup
            value={freqMinAlr}
            onChange={this.handleFreqMinAlrChange}
          />
        </FormGroup>

        <FormGroup
          helperText={t('dispMinAlrHelp')}
          label={t('dispMinAlr')}
          inline={true}
          style={formGroupStyle}
        >
          <NumericInput
            min={0} buttonPosition={null}
            value={dispMinAlr}
            onValueChange={(newValue) => onValueChange('alrParamValues', 'dispMinAlr', newValue)}
          />
        </FormGroup>

        <H4><u>{t('alrInitialization')}</u></H4>

        <FormGroup
          helperText={t('collocCatFilterHelp')}
          inline={true}
          label={t('collocCatFilter')}
          style={formGroupStyle}
        >
          <InputGroup
            value={collocCatFilter}
            onChange={this.handleCollocCatFilterChange}
            //onValueChange={(newValue) => onValueChange('alrParamValues', 'collocCatFilter', newValue)}
          />
        </FormGroup>

        <FormGroup
          label={t('amThreshold')}
          inline={true}
          style={formGroupStyle}
        >
          <NumericInput
            min={0} buttonPosition={null}
            value={amThreshold}
            onValueChange={(newValue) => onValueChange('alrParamValues', 'amThreshold', newValue)}
          />

        </FormGroup>

        <H4><u>{t('alrIterations')}</u></H4>

        <FormGroup
          label={t('maxNbCollocs')}
          inline={true}
          style={formGroupStyle}
        >
          <NumericInput
            min={0} buttonPosition={null}
            value={maxNbCollocs}
            onValueChange={(newValue) => onValueChange('alrParamValues', 'maxNbCollocs', newValue)}
          />

        </FormGroup>

        <FormGroup>
          <Switch
            checked={useCollig}
            name="useCollig"
            label={t('useCollig')}
            alignIndicator='right'
            onChange={this.handleBoolToTextChange}
          />
        </FormGroup>

        <H4><u>{t('alrResult')}</u></H4>

        <FormGroup
          helperText={t('minFreqChildrenRatio4DeduplicatingHelp')}
          label={t('minFreqChildrenRatio4Deduplicating')}
          inline={true}
          style={formGroupStyle}
        >
          <NumericInput
            min={0} buttonPosition={null}
            value={minFreqChildrenRatio4Deduplicating}
            onValueChange={(newValue) => onValueChange('alrParamValues', 'minFreqChildrenRatio4Deduplicating', newValue)}
          />
        </FormGroup>
        
        <FormGroup>
          <Switch
            checked={mergeAlr}
            name="mergeAlr"
            label={t('mergeAlr')}
            alignIndicator='right'
            onChange={this.handleBoolToTextChange}
          />
        </FormGroup>


      </>
    );
  }
}

AlrParams.propTypes = {
  values: PropTypes.shape({
    collocCatFilter: PropTypes.string,
    freqMinAlr: PropTypes.array,
    dispMinAlr: PropTypes.number,
    minSize: PropTypes.number,
    maxSize: PropTypes.number,
    amThreshold: PropTypes.number,
    maxNbCollocs: PropTypes.number,
    minFreqChildrenRatio4Deduplicating: PropTypes.number,
    useCollig: PropTypes.number,
    mergeAlr: PropTypes.number,

  }),
  onValueChange: PropTypes.func,
};

export default withTranslation()(AlrParams);